import { Label, Input } from "reactstrap";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./FiltersOptions.module.scss";

const FiltersOptions = ({ options, onChange, name, selected, isMultiple }) => {
  const checkIsSelected = (field) => {
    return selected && selected.length && selected.indexOf(field.value) !== -1;
  };

  const getIsDisabled = (field) =>
    selected[0] && selected[0] === "all" && field.value !== "all";

  const getMultipleValue = (field) => {
    const unSelectIndex = selected.indexOf(field);
    const newSelectedFields = [...selected];
    unSelectIndex !== -1
      ? newSelectedFields.splice(unSelectIndex, 1)
      : newSelectedFields.push(field);
    return newSelectedFields;
  };

  const onOptionSelected = (field, name) => {
    if (isMultiple) {
      const fields = getMultipleValue(field);
      onChange(fields, name);

      return;
    }
    onChange(field, name);
  };

  return (
    options.length > 0 &&
    options.map((field, index) => {
      return (
        <div className={styles.label} key={index}>
          <Label key={index}>
            <Input
              type="checkbox"
              className={cx(styles.checkbox, {
                [styles.disabled]: getIsDisabled(field),
              })}
              disabled={getIsDisabled(field)}
              checked={checkIsSelected(field)}
              onChange={() => onOptionSelected(field.value, name)}
              // onChange={() => onChange(field.value, name)}
            />
            <h5
              className={cx(styles.labelText, {
                [styles.disabled]: getIsDisabled(field),
              })}
            >
              {field.label}
            </h5>
          </Label>
        </div>
      );
    })
  );
};

FiltersOptions.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  name: PropTypes.string,
  selected: PropTypes.array,
  disabled: PropTypes.bool,
};

export default FiltersOptions;
